import * as React from "react";
const SvgFiRrConditionAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-condition-alt_svg__a)">
      <path
        fill="#062147"
        d="M21 11h-3.176l-4.09-2.958a3 3 0 0 0-.734-.39v-.798A3.51 3.51 0 0 0 15.5 3.5C15.5 1.57 13.93 0 12 0S8.5 1.57 8.5 3.5A3.51 3.51 0 0 0 11 6.854v.781a3 3 0 0 0-.794.416L6.174 11H3.001c-1.654 0-3 1.346-3 3v1a1 1 0 1 0 2 0v-1c0-.552.45-1 1-1h3.173l4.033 2.949a3 3 0 0 0 3.53.009L17.826 13h3.175c.551 0 1 .448 1 1v1a1 1 0 1 0 2 0v-1c0-1.654-1.346-3-3-3zM10.5 3.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5S12.827 5 12 5s-1.5-.673-1.5-1.5m2.062 10.837a1 1 0 0 1-1.177-.003L8.193 12l3.191-2.334a1 1 0 0 1 1.177-.003L15.792 12zm11.145 4.37L21.914 20.5l1.793 1.793a.999.999 0 1 1-1.414 1.414L20.5 21.914l-1.793 1.793a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1.793-1.793-1.793-1.793a.999.999 0 1 1 1.414-1.414l1.793 1.793 1.793-1.793a.999.999 0 1 1 1.414 1.414m-15.504-.919a1 1 0 0 1 .01 1.414L5.19 22.263A2.48 2.48 0 0 1 3.42 23c-.667 0-1.296-.26-1.768-.732L.293 20.91a.999.999 0 1 1 1.414-1.414l1.358 1.358a.501.501 0 0 0 .708 0l3.016-3.056a1 1 0 0 1 1.415-.01"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-condition-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrConditionAlt;
